import { API_USER_SERVICE } from "../config/Constants";
import { IAssignOrdersRequestDTO, IReassignOrderRequestDTO } from "../interfaces/Delivery";
import { getRequest, postRequest, putRequest } from "./Rest";

export const getDeliveryStats = async() => {
    const path = `${API_USER_SERVICE}/orders/stats`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
}
export const getDeliveryList = async(status:string, searchKeyword?:string, pincode?:string[], fromDate?:string, toDate?:string) => {
    let path = `${API_USER_SERVICE}/orders/delivery/packed-orders`;
    const params: string[] = [];
    if (status && status !== "all") params.push(`status=${status}`);
    if (searchKeyword) params.push(`searchKeyword=${searchKeyword}`);
    if (pincode?.length) pincode.forEach(p => params.push(`pincodes=${p}`));
    if (fromDate) params.push(`fromDate=${fromDate}`);
    if (toDate) params.push(`toDate=${toDate}`);
    if (params.length) path += `?${params.join("&")}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
}
export const getdeliveryAssignmentsList = async(searchKeyword?:string) =>{
    const path = `${API_USER_SERVICE}/orders/delivery/partners${searchKeyword ? `?searchKeyword=${searchKeyword}` : ""}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
}
export const getDeliveryOrderDetails = async(packageBarcode:string) =>{
    const path = `${API_USER_SERVICE}/orders/delivery/package/${packageBarcode}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const getDeliveryOrderDetailsPublic = async(packageBarcode:string) =>{
    const path = `${API_USER_SERVICE}/orders/public/delivery/package/${packageBarcode}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const getDeliveryOrderDetailsPublicByOrder = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/public/order/${orderId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const getReassignDeliveryPartners = async() =>{
    const path = `${API_USER_SERVICE}/orders/delivery/partners-summary`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const reAssignDelivery = async(dto:IReassignOrderRequestDTO) =>{
    const path = `${API_USER_SERVICE}/orders/delivery/reassign-order`;
    const response = await putRequest(path,dto);
    return response;
};
export const availablePartners = async(companyId:number,orderIds:number[]) =>{
    const path = `${API_USER_SERVICE}/orders/delivery/pincode-assignment?companyId=${companyId}`;
    const response = await postRequest(path,orderIds);
    return response;
}
export const bulkAssign = async(post:IAssignOrdersRequestDTO) =>{
    const path = `${API_USER_SERVICE}/orders/delivery/assign-orders`;
    const response = await postRequest(path,post);
    return response;
}
